'use client';
import { createContext } from '../create-context.mjs';

const [AccordionItemProvider, useAccordionItemContext] = createContext(
  {
    name: "AccordionItemContext",
    hookName: "useAccordionItemContext",
    providerName: "<AccordionItemProvider />"
  }
);

export { AccordionItemProvider, useAccordionItemContext };
